(() => {
  if (window.gridoneAccessoryPickerInstalled) return;
  window.gridoneAccessoryPickerInstalled = true;
  const priceInCents = input => {
    if (/^\d+$/.test(input.dataset.priceCents || '')) return Number(input.dataset.priceCents);
    const value = (input.dataset.price || '').replace(/(?:NOK|kr)/gi, '').replace(/[\s\u00a0\u202f]/g, '').replace(',', '.');
    return /^\d+(?:\.\d{1,2})?$/.test(value) ? Math.round(Number(value) * 100) : null;
  };
  const formatMoney = cents => new Intl.NumberFormat('nb-NO', {
    minimumFractionDigits: cents % 100 ? 2 : 0, maximumFractionDigits: 2
  }).format(cents / 100) + ' kr';
  function init() {
    document.querySelectorAll('[data-go-accessory-picker]').forEach(root => {
      if (root.dataset.goPickerInitialized) return;
      const inputs = Array.from(root.querySelectorAll('[data-go-deals-product]'));
      const list = root.querySelector('[data-go-deals-list]');
      const continueButton = root.querySelector('[data-go-deals-continue]');
      if (!inputs.length || !list || !continueButton) return;
      root.dataset.goPickerInitialized = 'true';
      const count = root.querySelector('[data-go-deals-count]');
      const empty = root.querySelector('[data-go-deals-empty]');
      const totalRow = root.querySelector('[data-go-deals-total-row]');
      const totalValue = root.querySelector('[data-go-deals-total]');
      const tax = root.querySelector('[data-go-deals-tax]');
      const clearButton = root.querySelector('[data-go-deals-clear]');
      const variants = Array.from(root.querySelectorAll('[data-go-picker-variant]'));
      const quantityInputs = Array.from(root.querySelectorAll('[data-go-picker-quantity]'));
      const hardwareInputs = Array.from(root.querySelectorAll('[data-go-picker-hardware]'));
      const normalizeQuantity = value => Math.max(1, Math.min(99, Math.floor(Number(value)) || 1));
      const selectionInfo = input => {
        const card = input.closest('[data-go-picker-card]');
        const quantityInput = card?.querySelector('[data-go-picker-quantity]');
        const hardware = card?.querySelector('[data-go-picker-hardware]');
        const quantity = quantityInput ? normalizeQuantity(quantityInput.value) : 1;
        const base = priceInCents(input);
        const extra = hardware?.checked ? Number(hardware.dataset.priceCents) : 0;
        const unitPrice = Number.isSafeInteger(base) ? base + extra : null;
        return {card, quantity, quantityInput, hardware, unitPrice, total: unitPrice === null ? null : unitPrice * quantity};
      };
      const pedals = inputs.filter(input => input.dataset.selectionGroup === 'pedals');
      const setup = pedals.length ? document.querySelector('[data-go-setup-select]') : null;
      const storageKey = 'gridone-accessory-selection:' + root.closest('[id^="shopify-section-"]').id;
      let stored;
      try {
        if (document.querySelector('[data-go-equipment-panel] [data-go-success]')) sessionStorage.removeItem(storageKey);
        else stored = JSON.parse(sessionStorage.getItem(storageKey) || 'null');
      } catch (_) {}
      inputs.forEach(input => { input.checked = Array.isArray(stored?.selected) && stored.selected.includes(input.value); });
      variants.forEach(select => {
        const saved = stored?.variants?.[select.id];
        if (saved && Array.from(select.options).some(option => option.value === saved && !option.disabled)) select.value = saved;
      });
      quantityInputs.forEach(input => {
        input.value = String(normalizeQuantity(stored?.quantities?.[input.id] ?? 1));
      });
      hardwareInputs.forEach(input => { input.checked = stored?.hardware?.[input.id] === true; });
      let inquiry = '';
      let selectedSetup = '';
      const notifyForm = focus => document.dispatchEvent(new CustomEvent('gridone:equipment-selection', {
        detail: {product: inquiry, focus, ...(pedals.length ? {setup: selectedSetup} : {})}
      }));
      function update() {
        variants.forEach(select => {
          const card = select.closest('[data-go-picker-card]');
          const input = card?.querySelector('[data-go-deals-product]');
          const option = select.selectedOptions[0];
          if (!input || !option) return;
          input.dataset.title = option.dataset.title;
          input.dataset.inquiry = option.dataset.title;
          input.dataset.price = option.dataset.price;
          input.dataset.priceCents = option.dataset.priceCents || '';
          const price = card.querySelector('[data-goa-price]');
          if (price) price.textContent = option.dataset.price;
        });
        const selected = inputs.filter(input => input.checked);
        selectedSetup = pedals.find(input => input.checked)?.dataset.inquiry || '';
        inputs.forEach(input => {
          const card = input.closest('[data-go-picker-card]');
          card?.classList.toggle('is-selected', input.checked);
          const label = card?.querySelector('[data-go-deals-select-label]');
          if (label) label.textContent = input.checked ? root.dataset.selectedLabel : root.dataset.selectLabel;
          const info = selectionInfo(input);
          if (info.quantityInput) {
            const price = card.querySelector('[data-goa-price]');
            if (price && info.unitPrice !== null) price.textContent = formatMoney(info.unitPrice);
            const line = card.querySelector('[data-go-line-total-row]');
            line.hidden = !input.checked || info.total === null;
            card.querySelector('[data-go-line-total]').textContent = info.total === null ? '' : formatMoney(info.total);
            const hardwareNote = card.querySelector('[data-go-without-note]');
            if (hardwareNote && info.hardware) hardwareNote.hidden = info.hardware.checked;
            const decrease = card.querySelector('[data-go-quantity-step="-1"]');
            const increase = card.querySelector('[data-go-quantity-step="1"]');
            decrease.disabled = info.quantity <= 1;
            increase.disabled = info.quantity >= 99;
          }
        });
        list.replaceChildren();
        selected.forEach(input => {
          const item = document.createElement('li');
          const title = document.createElement('span');
          const price = document.createElement('span');
          const info = selectionInfo(input);
          title.textContent = (info.quantityInput ? info.quantity + ' × ' : '') + input.dataset.title;
          if (info.hardware) title.textContent += ', ' + (info.hardware.checked ? info.hardware.dataset.withLabel : info.hardware.dataset.withoutLabel).toLowerCase();
          price.textContent = info.total === null ? input.dataset.price : formatMoney(info.total);
          item.append(title, price);
          list.append(item);
        });
        const prices = selected.map(input => selectionInfo(input).total);
        const completePrices = selected.length > 0 && prices.every(Number.isSafeInteger);
        const total = completePrices ? prices.reduce((sum, price) => sum + price, 0) : null;
        count.textContent = String(selected.length);
        empty.hidden = selected.length > 0;
        list.hidden = selected.length === 0;
        totalRow.hidden = !completePrices;
        totalValue.textContent = completePrices ? formatMoney(total) : '';
        tax.hidden = selected.length === 0;
        continueButton.disabled = selected.length === 0;
        clearButton.hidden = selected.length === 0;
        const lines = selected.map(input => {
          const info = selectionInfo(input);
          let line = (info.quantityInput ? info.quantity + ' × ' : '') + (input.dataset.inquiry || input.dataset.title);
          if (info.hardware) line += ', ' + (info.hardware.checked ? info.hardware.dataset.withLabel : info.hardware.dataset.withoutLabel).toLowerCase();
          if (info.total !== null) line += ' (' + (info.quantityInput ? formatMoney(info.unitPrice) + ' ' + (input.dataset.unitLabel || 'per stk.') + ', ' : '') + formatMoney(info.total) + ')';
          else if (input.dataset.price) line += ' (' + input.dataset.price + ')';
          return line;
        });
        if (completePrices) lines.push('', root.dataset.totalLabel + ': ' + formatMoney(total), root.dataset.taxLabel);
        inquiry = lines.join('\n');
        try {
          sessionStorage.setItem(storageKey, JSON.stringify({selected: selected.map(input => input.value), variants: Object.fromEntries(variants.map(select => [select.id, select.value])), quantities: Object.fromEntries(quantityInputs.map(input => [input.id, normalizeQuantity(input.value)])), hardware: Object.fromEntries(hardwareInputs.map(input => [input.id, input.checked]))}));
        } catch (_) {}
        notifyForm(false);
      }
      inputs.forEach(input => input.addEventListener('change', () => {
        if (input.checked && input.dataset.selectionGroup) {
          inputs.forEach(other => { if (other !== input && other.dataset.selectionGroup === input.dataset.selectionGroup) other.checked = false; });
        }
        update();
      }));
      variants.forEach(select => select.addEventListener('change', update));
      const selectForOption = control => {
        const selected = control.closest('[data-go-picker-card]')?.querySelector('[data-go-deals-product]');
        if (selected) selected.checked = true;
      };
      quantityInputs.forEach(input => {
        input.addEventListener('input', () => {
          if (input.value === '') return;
          input.value = String(normalizeQuantity(input.value));
          selectForOption(input);
          update();
        });
        input.addEventListener('change', () => {
          input.value = String(normalizeQuantity(input.value));
          selectForOption(input);
          update();
        });
      });
      hardwareInputs.forEach(input => input.addEventListener('change', () => { selectForOption(input); update(); }));
      root.querySelectorAll('[data-go-quantity-step]').forEach(button => button.addEventListener('click', () => {
        const input = button.closest('[data-go-picker-card]').querySelector('[data-go-picker-quantity]');
        input.value = String(normalizeQuantity(normalizeQuantity(input.value) + Number(button.dataset.goQuantityStep)));
        selectForOption(input);
        update();
      }));
      setup?.addEventListener('change', () => {
        pedals.forEach(input => { input.checked = input.dataset.inquiry === setup.value; });
        update();
      });
      clearButton.addEventListener('click', () => {
        inputs.forEach(input => { input.checked = false; });
        quantityInputs.forEach(input => { input.value = '1'; });
        hardwareInputs.forEach(input => { input.checked = false; });
        update();
        inputs[0]?.focus();
      });
      continueButton.addEventListener('click', () => {
        if (!inquiry) return;
        const panel = document.querySelector('[data-go-equipment-panel]');
        if (panel?.querySelector('input[type="email"]')) notifyForm(true);
        else {
          const url = new URL(root.dataset.inquiryUrl, location.origin);
          url.searchParams.set('interesse', 'accessories');
          url.searchParams.set('produkt', inquiry);
          url.hash = 'gridone-contact';
          location.assign(url.href);
        }
      });
      root.querySelectorAll('[data-go-deals-enhanced]').forEach(element => { element.hidden = false; });
      root.querySelectorAll('[data-go-deals-fallback]').forEach(element => { element.hidden = true; });
      update();
      if (document.readyState !== 'complete') window.addEventListener('load', () => notifyForm(false), {once: true});
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, {once: true});
  else init();
  document.addEventListener('shopify:section:load', init);
})();
